import { mapValues } from "lodash";

export enum TestId {
  SecurityPage = "security-page",
  TeamPage = "team-page",
  ProfilePage = "profile-page",
  AlertsPage = "alerts-page",
  AccountKitPage = "account-kit-page",
  ActivityLogsPage = "activity-logs-page",

  BillingPage = "billing-page",

  AppsPage = "apps-page",
  MyAppsCard = "my-apps-card",
  AppDetailsPage = "app-details-page",

  BundlerApiPage = "bundler-api-page",
  ChainsPage = "chains-page",
  DebugApiPage = "debug-api-page",
  EmbeddedAccountsPage = "embedded-accounts-page",
  GasManagerApiPage = "gas-manager-api-page",
  GasManagerPage = "gas-manager-page",
  HomePage = "home-page",
  MempoolPage = "mempool-page",
  MempoolTransactionPage = "mempool-transaction-page",
  NftApiPage = "nft-api-page",
  NodeApiPage = "node-api-page",
  RequestLogsPage = "request-logs-page",
  RollupsPage = "rollups-page",
  RollupDetailPage = "rollup-detail-page",
  SandboxPage = "sandbox-page",
  ServicesPage = "services-page",
  TokenApiPage = "token-api-page",
  TraceApiPage = "trace-api-page",
  TransactionReceiptsApiPage = "transaction-receipts-api-page",
  TransactionSimulationApiPage = "transaction-simulation-api-page",
  TransfersApiPage = "transfers-api-page",
  UsagePage = "usage-page",
  UserOperationsApiPage = "user-operations-api-page",
  WebhooksPage = "webhooks-page",
  WebsocketsPage = "smart-websockets-page",
  ThroughputPage = "throughput-page",
  NavCoachMark = "nav-coach-mark",
}

function createWrapIdBuilder<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string, (...args: any[]) => string>,
>(testId: TestId, builders: T): T {
  return mapValues(builders, (builder) => {
    return (...args: unknown[]) => `${testId}-${builder(...args)}`;
  }) as T;
}

export const testIdBuilder = {
  billing: createWrapIdBuilder(TestId.BillingPage, {
    planSpendLimit: () => `plan-spend-limit`,
    updatePlanSpendLimitBtn: () => `btn-update-plan-spend-limit`,
    updateBillingAddressBtn: () => `btn-update-billing-address`,
    updateTaxIdBtn: () => `btn-update-tax-id`,
    addCCEmailBtn: () => `btn-add-cc-email`,
    deleteCCEmailBtn: (email: string) => `btn-delete-cc-email-${email}`,
    ccEmail: (email: string) => `cc-email-${email}`,
    upgradeBtn: () => `btn-upgrade`,
    downgradeBtn: () => `btn-downgrade`,
    upgradeModalContinueBtn: () => `up-modal-btn-continue`,
    upgradeModalConfirmBtn: () => `up-modal-btn-confirm`,
    upgradeModalFinishBtn: () => `up-modal-btn-finish`,
    downgradeModalContinueBtn: () => `dn-modal-btn-continue`,
    downgradeConfirmBtn: () => `btn-confirm-downgrade`,
  }),
  navCoachMark: createWrapIdBuilder(TestId.NavCoachMark, {
    closeBtn: () => `btn-close`,
  }),
  appDetails: createWrapIdBuilder(TestId.AppDetailsPage, {
    setup: () => `setup`,
    metrics: () => `metrics`,
    networks: () => `networks`,
    security: () => `security`,
    settings: () => `settings`,
  }),
  throughput: createWrapIdBuilder(TestId.ThroughputPage, {
    fcupsLimit: () => `fcups-limit`,
  }),
};
